import { QueryResult } from 'react-query';
// eslint-disable-next-line import/no-cycle
import { ArtikelEigenschaft } from './artikelEigenschaft';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
import type { ArtikelAttachment } from './artikelAttachment';
import type { Maschinentype } from './maschinentype';

export interface Artikel {
    nr: string;
    text: string;
    einheit: string;
    packEinheit: number;
    staerke: number;
    breite: number;
    halbeBreite: boolean;
    laufmeter: number;
    quadrmeter: number;
    spezGew: number;
    kernGew: number;
    rollenGew: number;
    nettoGew: number;
    einhProPal: number;
    bestPal: boolean;
    bestKart: boolean;
    kalkBlatt: string;
    prodInfoUes: string;
    prodInfo: string;
    bemerkung: string;
    land: string;
    ean: string;
    archiv: boolean;
    bild: string;
    bhCode: string;
    artikelNrLieferant: string;
    kernId: number;
    zollTarif: string;
    doku: string;

    artikelEigenschaftList: ArtikelEigenschaft[];
    maschinentypeList: Maschinentype[];
    artikelAttachmentList: ArtikelAttachment[];

    anlageDat?: string;
    anlageUhr?: number;
    anlageUser?: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export const defaultArtikel: Artikel = {
    nr: '',
    text: '',
    einheit: '',
    packEinheit: 0,
    staerke: 0,
    breite: 0,
    halbeBreite: false,
    laufmeter: 0,
    quadrmeter: 0,
    spezGew: 0,
    kernGew: 0,
    rollenGew: 0,
    nettoGew: 0,
    einhProPal: 0,
    bestPal: false,
    bestKart: false,
    kalkBlatt: '',
    prodInfoUes: '',
    prodInfo: '',
    bemerkung: '',
    land: '',
    ean: '',
    archiv: false,
    bild: '',
    bhCode: 'H',
    artikelNrLieferant: '',
    kernId: 0,
    zollTarif: '',
    doku: '',

    artikelEigenschaftList: [],
    maschinentypeList: [],
    artikelAttachmentList: [],
};

export interface ArtikelFilter {
    artikelNr?: string;
    artikelNrList?: string[];
    artikelGruppeNr?: number;
    searchText?: string;
    includeArchiv?: boolean;
    maxRows?: number;
    withArtikelEigenschaften?: boolean;
    withMaschinentypen?: boolean;
    withArtikelAttachments?: boolean;
}

export function useArtikel(filter: ArtikelFilter, apiOptions?: UseApiOptions<Artikel>): QueryResult<Artikel> {
    return useApi<Artikel>(Controller.artikel + '/one', { filter }, apiOptions);
}

export function useArtikelList(filter: ArtikelFilter, apiOptions?: UseApiOptions<Artikel[]>): QueryResult<Artikel[]> {
    return useApi<Artikel[]>(Controller.artikel + '/list', { filter }, apiOptions);
}

export async function getArtikel(filter: ArtikelFilter): Promise<Artikel> {
    return callApi<Artikel>(Controller.artikel + '/one', {
        filter,
    });
}

export async function addArtikel(artikel: Artikel): Promise<void> {
    return callApi<void>(Controller.artikel + '/add', { artikel });
}

export async function updateArtikel(artikel: Artikel): Promise<void> {
    return callApi<void>(Controller.artikel + '/update', { artikel });
}
